<form [formGroup]="frmGroup" (ngSubmit)="onSave()">
    <div class="change-password-card">
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group position-relative">
                    <label class="main-label d-block fw-medium text-black">Old Password</label>
                    <input [type]="isPassword1Visible ? 'text' : 'password'" placeholder="Old Password"
                        formControlName="oldPasswordControl" maxlength="100" class="form-control"
                        placeholder="Type password" />
                    <button type="button" (click)="togglePassword1Visibility()"
                        class="icon-button p-0 border-0 bg-transparent transition">
                        <i [ngClass]="isPassword1Visible ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                    </button>
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('required') && f['oldPasswordControl']!.touched">
                    Old Password is required.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('hasCharacters') && f['oldPasswordControl']!.touched">
                    Minimum Password length should be 8 characters.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('hasUpper') && f['oldPasswordControl']!.touched">
                    Password must contain at least one uppercase.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('hasLower') && f['oldPasswordControl']!.touched">
                    Password must contain at least one lowercase.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('hasNumber') && f['oldPasswordControl']!.touched">
                    Password must contain at least one number.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('hasSpecialChar') && f['oldPasswordControl']!.touched">
                    Password must contain at least one special character.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['oldPasswordControl']!.hasError('mustMatch') && f['oldPasswordControl']!.touched">
                    Confirm Password must be match with password.
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group position-relative">
                    <label class="main-label d-block fw-medium text-black">New Password</label>
                    <input [type]="isPassword2Visible ? 'text' : 'password'" placeholder="New Password"
                        formControlName="newPasswordControl" maxlength="100" class="form-control"
                        placeholder="Type password" />
                    <button type="button" (click)="togglePassword2Visibility()"
                        class="icon-button p-0 border-0 bg-transparent transition">
                        <i [ngClass]="isPassword2Visible ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                    </button>
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('required') && f['newPasswordControl']!.touched">
                    New Password is required.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('hasCharacters') && f['newPasswordControl']!.touched">
                    Minimum Password length should be 8 characters.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('hasUpper') && f['newPasswordControl']!.touched">
                    Password must contain at least one uppercase.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('hasLower') && f['newPasswordControl']!.touched">
                    Password must contain at least one lowercase.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('hasNumber') && f['newPasswordControl']!.touched">
                    Password must contain at least one number.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('hasSpecialChar') && f['newPasswordControl']!.touched">
                    Password must contain at least one special character.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['newPasswordControl']!.hasError('mustMatch') && f['newPasswordControl']!.touched">
                    Confirm Password must be match with password.
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group position-relative">
                    <label class="main-label d-block fw-medium text-black">Confirm Password</label>
                    <input [type]="isPassword3Visible ? 'text' : 'password'" placeholder="Confirm Password"
                        formControlName="confirmPasswordControl" maxlength="100" class="form-control"
                        placeholder="Type password" />
                    <button type="button" (click)="togglePassword3Visibility()"
                        class="icon-button p-0 border-0 bg-transparent transition">
                        <i [ngClass]="isPassword3Visible ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                    </button>
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('required') && f['confirmPasswordControl']!.touched">
                    Confirm Password is required.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('hasCharacters') && f['confirmPasswordControl']!.touched">
                    Minimum Password length should be 8 characters.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('hasUpper') && f['confirmPasswordControl']!.touched">
                    Password must contain at least one uppercase.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('hasLower') && f['confirmPasswordControl']!.touched">
                    Password must contain at least one lowercase.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('hasNumber') && f['confirmPasswordControl']!.touched">
                    Password must contain at least one number.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('hasSpecialChar') && f['confirmPasswordControl']!.touched">
                    Password must contain at least one special character.
                </div>
                <div class="form-text text-danger"
                    *ngIf="f['confirmPasswordControl']!.hasError('mustMatch') && f['confirmPasswordControl']!.touched">
                    Confirm Password must be match with password.
                </div>
            </div>
        </div>
        <div class="form-btn-box">
            <button [disabled]="!formIsValid()"
                class="primary d-inline-block fw-medium border-radius border-0 transition">
                <span class="d-inline-block position-relative">
                    <i class="material-symbols-outlined">check</i>
                    Change Password
                </span>
            </button>
            <!-- <a routerLink="/forgot-password" class="fs-14 text-danger">
                Forgot Password?
            </a> -->
        </div>
    </div>
</form>